<div [formGroup]="boxForm" fxLayout="column">
  <div *ngIf="generalError" class="mat-error">
    {{generalError?.message}}
  </div>

  <mat-form-field>
    <mat-label>Hardware Version </mat-label>
    <input formControlName="hardwareVersion" matInput name="hardwareVersion" type="text">
    <mat-error
      *ngIf="boxForm.controls.hardwareVersion?.errors?.pattern && !boxForm.controls.hardwareVersion?.errors?.required">
      Please enter a valid hardware version
    </mat-error>
    <mat-error *ngIf="boxForm.controls.hardwareVersion?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Identifier </mat-label>
    <input formControlName="identifier" matInput name="identifier" type="text">
    <mat-error *ngIf="boxForm.controls.identifier?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Software Version </mat-label>
    <input formControlName="softwareVersion" matInput name="softwareVersion" type="text">
    <mat-error
      *ngIf="boxForm.controls.softwareVersion?.errors?.pattern && !boxForm.controls.softwareVersion?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <ng-container>
  <mat-form-field>
  <mat-label>Location</mat-label>
  <mat-select [(ngModel)]="selectedLocation"  formControlName="boxLocation" name="boxLocation" [compareWith]="compareFn">
    <mat-option *ngIf="!loadingLocation && boxLocations.length === 0">
      No location available.
    </mat-option>
    <mat-option *ngFor="let boxLocation of boxLocations" [value]="boxLocation">
      {{boxLocation.region}}
    </mat-option>
</mat-select>
<span *ngIf="loadingLocation" matPrefix><i class="fas fa-spinner fa-spin color-primary"></i>&nbsp;</span>
</mat-form-field>
</ng-container>


  <ng-container *ngIf="!isEditing">
    <mat-form-field>
      <mat-label>Sim</mat-label>
      <mat-select [(value)]="selectedSim" [disabled]="isEditing" formControlName="sim" name="sim">

        <mat-option *ngIf="!loadingSims && sims.length === 0">
          No sims available.
        </mat-option>
        <mat-option *ngFor="let sim of sims" [value]="sim">
          {{sim?.identifier}}
        </mat-option>
      </mat-select>
      <span *ngIf="loadingSims" matPrefix><i class="fas fa-spinner fa-spin color-primary"></i>&nbsp;</span>
      <button (click)="$event.stopPropagation();openSimForm()" class="z-front" color="primary" mat-button matSuffix>
        <!--      <mat-icon>developer_mode</mat-icon>-->
        New
      </button>
      <mat-hint *ngIf="!loadingSims && sims.length === 0" class="color-warn">
        No sims available.
      </mat-hint>
    </mat-form-field>
  </ng-container>

  <ng-container *ngIf="!isEditing">
    <mat-form-field>
      <mat-label>Interfaces</mat-label>
      <mat-select [(value)]="selectedBoxInterfaces" [disabled]="isEditing" formControlName="boxInterfaces" multiple
        name="interfaces">

        <mat-option *ngIf="!loadingBoxInterfaces && boxInterfaces.length === 0">
          No interfaces available.
        </mat-option>
        <mat-option *ngFor="let boxInterface of boxInterfaces" [value]="boxInterface">
          {{boxInterface.name}}
        </mat-option>
      </mat-select>
      <span *ngIf="loadingBoxInterfaces" matPrefix><i class="fas fa-spinner fa-spin color-primary"></i>&nbsp;</span>
      <button (click)="$event.stopPropagation();openBoxInterfaceForm()" class="z-front" color="primary" mat-button
        matSuffix>
        <!--      <mat-icon>developer_mode</mat-icon>-->
        New
      </button>
      <mat-hint class="color-warn" *ngIf="!loadingBoxInterfaces && boxInterfaces.length === 0">
        No interfaces available.
      </mat-hint>
    </mat-form-field>
  </ng-container>

  <!--  <mat-form-field *ngIf="!loadingContracts else loadingItem">-->
  <!--    <mat-label>Contract</mat-label>-->
  <!--    <mat-select formControlName="contracts" name="contracts" [(value)]="selectedContract" [disabled]="isEditing">-->
  <!--      <mat-option *ngFor="let contract of contracts" [value]="contract">-->
  <!--        {{contract.title}}-->
  <!--      </mat-option>-->
  <!--    </mat-select>-->
  <!--  </mat-form-field>-->
  <!--  <mat-error *ngIf="!loadingContracts && contracts.length === 0">-->
  <!--    No contracts available.-->
  <!--  </mat-error>-->


  <!--  <mat-form-field *ngIf="!loadingCertificates else loadingItem">-->
  <!--    <mat-label>Certificate</mat-label>-->
  <!--    <mat-select formControlName="certificate" name="certificate" [(value)]="selectedCertificate" [disabled]="isEditing">-->
  <!--      <mat-option *ngFor="let certificate of certificates" [value]="certificate">-->
  <!--        {{certificate.cmId}}-->
  <!--      </mat-option>-->
  <!--    </mat-select>-->
  <!--  </mat-form-field>-->
  <!--  <mat-error *ngIf="!loadingCertificates && certificates.length === 0">-->
  <!--    No certificates available.-->
  <!--  </mat-error>-->


  <div fxLayout="row" fxLayoutAlign="end">
    <button (click)="box = _box; canceled.emit()" mat-button>Cancel</button>
    <button (click)="saveBox()" [disabled]="boxForm.invalid || saving " color="primary" mat-button>
      <i *ngIf="saving" class="fas fa-spinner fa-spin"></i>
      <ng-container *ngIf="!saving">Save</ng-container>
    </button>
  </div>

</div>